import { Component, Input } from '@angular/core';

export type MessageType = 'info' | 'warning' | 'error' | 'novalue';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
})
export class MessageComponent {
  @Input() classNames = '';
  @Input() type: MessageType = 'novalue';
  @Input() title = 'No title';
}
